import { useState } from 'react';
import styled from 'styled-components';

import { UnorderedList } from '@r1-frontend/ui-react/components/List';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const ListDataForPopup = [
    'Держите под рукой свой паспорт или доверенность на&nbsp;того, кто будет встречать инженера вместо вас.',
    'Вспомните логин и&nbsp;пароль от&nbsp;Госуслуг, чтобы быстро ввести их&nbsp;и&nbsp;подписать документы.',
    'Убедитесь, что на&nbsp;вашей карте хватает денег для оплаты услуг.',
];

const HowToPrepare = ({ className }: { className?: string }): JSX.Element => {
    const [isOpen, changePopupState] = useState(false);

    const handleClosePopup = () => {
        changePopupState(false);
    };

    const handleOpenPopup = () => {
        changePopupState(true);
    };

    return (
        <>
            <ControlElement
                type={'large'}
                Icon={InfoCircleFlip}
                onClick={handleOpenPopup}
            >
                Как подготовиться?
            </ControlElement>

            <DefaultPopup isOpen={isOpen} onClose={handleClosePopup} className={className}>
                <IndentContainer $desktop={[32]} $mobile={[24]}>
                    <Paragraph4 $withIndent={true} $color={COLORS.TextSecondary}>
                        На все работы инженеру понадобится около 60 минут.
                    </Paragraph4>
                    <Paragraph4>
                        <b>Как подготовиться в визиту инженера:</b>
                    </Paragraph4>
                    <UnorderedList>
                        {ListDataForPopup.map(item => {
                            return <Paragraph4
                                key={item}
                                as={'li'}
                                dangerouslySetInnerHTML={{ __html: item }}
                            />;
                        })}
                    </UnorderedList>
                </IndentContainer>
            </DefaultPopup>
        </>
    );
};

export default styled(HowToPrepare)`
    & > ${IndentContainer} > ${Paragraph4}:first-child {
        max-width: calc(100% - 40px);
    }
`;
